import log from 'salvo-lite/log'
class ProductSticky {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._quantityInput = this._elem.querySelector('.QuantitySelector__CurrentQuantity') // sticky quantity selector
        this._mainQuantityInput = document.querySelector('.QuantitySelector--main') // main pdp quantity selector
        this._rechargeWidget = document.querySelector('.recharge-subscription-widget')
        this._stickySellingplanInput = this._elem.querySelector('#sticky-selling-plan')
        this._makeSelection = this._elem.querySelector('.product-sticky__make-selection')
        this._mainATC = document.querySelector('.ProductForm__BuyButtons') // main form ATC
        this._selectOptionsMessage = document.querySelector('.ProductForm__option-message') // message on main form
    }

    onInit () {
        log.debug(this.constructor.name, 'Constructed', this)
        if (this._mainQuantityInput && this._quantityInput) {
            this._quantitySelector()
        }
        this._handleScroll()

        if (this._rechargeWidget) {
            this._handleRecharge(this._rechargeWidget)
        }

        if (this._makeSelection) {
            this._handleMakeSelection()
        }
    }

    _updateSellingPlan () {
        const sellingPlanInput = document.querySelectorAll('input[name="selling_plan"]')[0] // selling plan input on main product form
        const sellingPlanValue = sellingPlanInput.value

        if (sellingPlanValue != null) {
            this._stickySellingplanInput.value = sellingPlanValue
        }
    }

    _handleRecharge (rechargeApp) {
        const observer = new MutationObserver((mutationsList) => {
            this._updateSellingPlan(rechargeApp, observer)
        })

        const config = {
            childList: true,
            subtree: true
        }

        observer.observe(rechargeApp, config)
    }

    _calculateScroll () {
        const elementRect = this._mainATC.getBoundingClientRect()
        let mainAtcScrollPosition = elementRect.top
        let absoluteElementTop = mainAtcScrollPosition + window.pageYOffset - 100

        if (window.scrollY > absoluteElementTop) {
            this._elem.classList.add('scrolled')
        } else {
            // If scrolled less than or equal to 60 pixels, hide sticky bar
            this._elem.classList.remove('scrolled')
        }
    }

    _handleScroll () {
        window.addEventListener('scroll', () => {
            this._calculateScroll()
        })
    }

    _handleQuantityChange (button) {
        const buttonAction = button.dataset.action
        const currentValueSticky = parseInt(this._quantityInput.value) // Value of sticky quantity
        const currentValueMain = parseInt(this._mainQuantityInput.value) // Value of main quantity
        const quantityType = button.dataset.quantityType

        switch (buttonAction) {
        case 'increase-quantity':
            this._quantityInput.value = currentValueSticky + 1
            if (quantityType === 'sticky') {
                this._mainQuantityInput.value = currentValueMain + 1
            }
            break
        case 'decrease-quantity':
            if (currentValueSticky > 1) {
                this._quantityInput.value = currentValueSticky - 1
                this._mainQuantityInput.value = currentValueMain - 1
            }
            break
        }
    }

    _handleQuantityInput (updateInput, value) {
        // handle input value changed
        updateInput.value = value
    }

    _quantitySelector () {
        const qtySelectorButtons = document.querySelectorAll('.QuantitySelector__Button')

        qtySelectorButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                this._handleQuantityChange(button)
            })
        })

        this._quantityInput.addEventListener('input', (e) => {
            this._handleQuantityInput(this._mainQuantityInput, e.target.value)
        })

        this._mainQuantityInput.addEventListener('input', (e) => {
            this._handleQuantityInput(this._quantityInput, e.target.value)
        })
    }

    _handleMakeSelection () {
        this._makeSelection.addEventListener('click', (e) => {
            this._selectOptionsMessage.classList.add('active')

            const elementRect = this._selectOptionsMessage.getBoundingClientRect()
            let scrollPosition = elementRect.top
            let absoluteElementTop = elementRect.top + window.pageYOffset
            scrollPosition = absoluteElementTop - (window.innerHeight / 2)

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
            })
        })
    }
}

export default ProductSticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductSticky.js